<div class="claim-sidebar">
  <h2 class="title">{{ "Upload claim documents" }}</h2>
</div>
<div class="d-flex pt-2 claim-sidebar">
  <div class="d-flex">
    <img src="./assets/img/images/icon-file-document.svg" alt="document file" />
    <div class="mb-2">
      {{ "Upload important claim" | translate }}
      <div>{{ "documents for your adjuster." | translate }}</div>
    </div>
  </div>
  <div>
     <mapfre-button
      [routerLink]="['/claims/' + claimId + '/upload-documents']"
      additionalClasses="ghost primary a-h24 x-small-btn sendDocBtn w-100-mobile"
    >
      {{ "Upload documents" }}
    </mapfre-button>
  </div>
</div>
